import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { challengesService } from 'src/services/challenges.service'



export const useGetLeaderboard = () => {
  return useQuery(
    [QUERY_KEYS.CHALENGES_LEADERBOARD],
    () =>
      challengesService.getChallengesLeaderboard(),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 12 * 60 * 1000,
    },
  )
}
